import templateComponents from '../../../Template/theme/components'
import auto from './auto'

export default {
    ...templateComponents,
    auto
}


// WEBPACK FOOTER //
// ./src/app/configuration/FordAP/theme/components/index.js